var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('hero'),_c('basic-elements'),_c('inputs'),_c('elements'),_c('spinners'),_c('custom-controls'),_c('navigation'),_c('tabs'),_c('progress-pagination'),_c('labels'),_c('alerts'),_c('footer-areas'),_c('typography'),_c('content-areas'),_c('cards'),_c('javascript-components'),_c('carousel'),_c('nucleo-icons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }